import { render, staticRenderFns } from "./OrderAccept.vue?vue&type=template&id=d87a323a&"
import script from "./OrderAccept.vue?vue&type=script&lang=ts&"
export * from "./OrderAccept.vue?vue&type=script&lang=ts&"
import style0 from "./OrderAccept.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports